<template>
    <Card :title="$t('pages.MainInformation')">
        <div class="card-body">
            <div class="row">
                <div class="col-lg-2">
                    <FormGroup :label="$t('labels.image')">
                        <ImageInputGroup v-model:image="image" type="product-item" />
                    </FormGroup>
                </div>
                <div class="col-lg-4">
                    <FormGroup :label="$t('labels.name')" required>
                        <Input v-model="name" />
                    </FormGroup>
                </div>
                <div class="col-lg-2">
                    <FormGroup :label="$t('labels.sku')">
                        <Input v-model="sku" />
                    </FormGroup>
                </div>
                <div class="col-lg-2">
                    <FormGroup :label="$t('labels.category')">
                        <AppAutoComplete
                            :url="`/projects/${$route.params.projectUuid}/pim/types`"
                            :model-value="category?.uuid"
                            :selected-value="category?.name"
                            @update:model-value="category = $event"
                        />
                    </FormGroup>
                </div>
                <div class="col-lg-2">
                    <FormGroup :label="$t('labels.measurement')">
                        <AppSelect
                            :model-value="measurement?.value"
                            :selected-value="measurement?.label"
                            :options="measurementOptions"
                            @update:model-value="measurement = $event"
                            option-key="value"
                            option-value="label"
                        />
                    </FormGroup>
                </div>
                <div class="col-lg-2">
                    <FormGroup :label="$t('labels.manufacturer')">
                        <Input v-model="manufacturer" />
                    </FormGroup>
                </div>
                <div class="col-lg-2">
                    <FormGroup :label="$t('labels.group_key')">
                        <Input v-model="groupKey" />
                    </FormGroup>
                </div>
                <div class="col-lg-2">
                    <FormGroup :label="$t('labels.cost')">
                        <Input v-model="cost" type="number" @update:model-value="setDefaultCurrency" />
                    </FormGroup>
                </div>
                <div class="col-lg-2">
                    <FormGroup :label="$t('labels.cost_currency')">
                        <AppSelect
                            :model-value="costCurrency?.uuid"
                            :selected-value="costCurrency?.name"
                            :options="currencies"
                            @update:model-value="costCurrency = $event"
                            option-key="uuid"
                            option-value="name"
                        />
                    </FormGroup>
                </div>
                <div class="col-lg-2">
                    <FormGroup :label="$t('labels.automatic_arrival')">
                        <AppCheckbox v-model="automaticArrival" />
                    </FormGroup>
                </div>
            </div>
        </div>
        <div class="card-footer d-flex justify-content-end">
            <AppButton color="indigo" @click="create()">
                {{ $t('buttons.create') }}
            </AppButton>
        </div>
    </Card>
</template>
<script>
import Card from "../../../../components/new/CardComponent.vue";
import ImageInputGroup from "../../../components/input/ImageInputGroup.vue";
import FormGroup from "../../../../components/new/form/group/FormGroup.vue";
import Input from "../../../../components/new/form/Input.vue";
import AppCheckbox from "../../../../components/new/form/checkbox/AppCheckbox.vue";
import AppButton from "../../../../components/new/button/AppButton.vue";
import AppAutoComplete from "../../../../components/new/form/autocomplete/AppAutoComplete.vue";
import AppSelect from "../../../../components/new/form/select/AppSelect.vue";

import MeasurementEnum from "../../../enums/MeasurementEnum";
import { httpClient } from "../../../../services/HttpClient";

export default {
    name: "ProductCreatePage",
    components: {
        Card, ImageInputGroup, FormGroup, Input, AppCheckbox, AppButton, AppAutoComplete, AppSelect
    },
    data() {
        return {
            measurementOptions: [],
            image: null,
            name: '',
            sku: '',
            category: '',
            measurement: null,
            manufacturer: '',
            groupKey: null,
            automaticArrival: false,
            costCurrency: null,
            cost: null,
            currencies: []
        }
    },
    methods: {
        create() {
            let request = {
                name: this.name
            }

            if (this.sku) {
                request.sku = this.sku;
            }

            if (this.category) {
                request.category_uuid = this.category.uuid;
            }

            if (this.measurement) {
                request.measurement = this.measurement.value;
            }

            if (this.manufacturer) {
                request.manufacturer = this.manufacturer;
            }

            if (this.groupKey) {
                request.group_key = this.groupKey;
            }

            if (this.image) {
                request.files = [{
                    file_uuid: this.image.uuid,
                }];
            }

            if (this.cost) {
                request.cost = this.cost;
            }

            if (this.costCurrency) {
                request.cost_currency_uuid = this.costCurrency.uuid;
            }

            if (this.automaticArrival) {
                request.automatic_arrival = this.automaticArrival;
            }

            httpClient.post('/catalog/product-items', request).then((response) => {
                this.$router.replace({ name: 'EditProductPage', params: { productUuid: response.data.data.uuid } })
            })
        },
        fetchCurrencies() {
            httpClient.get('/list/currencies', {
                limit: 100
            }).then((response) => {
                this.currencies = response.data.data;
            })
        },
        setDefaultCurrency() {
            if (this.currencies.length > 1) {
                return;
            }

            this.costCurrency = this.currencies[0];
        }
    },
    mounted() {
        this.fetchCurrencies();
        this.measurementOptions = Object.values(MeasurementEnum).map((value) => {
            return {
                value,
                label: this.$t(`measurement.${value}`)
            }
        })
    }
}
</script>
